import React, { useState } from 'react';

// 1. Definimos las interfaces con TypeScript
export interface CarouselSlide {
  id: string | number;
  image: string;
  title?: string;
  description?: string;
}

interface CarouselProps {
  slides: CarouselSlide[];
  autoPlay?: boolean;
}

export const Carousel: React.FC<CarouselProps> = ({ slides }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  if (!slides || slides.length === 0) {
    return <div className="p-4 text-center text-gray-500">No hay diapositivas para mostrar.</div>;
  }

  const goToSlide = (index: number) => {
    setActiveSlide(index);
    const element = document.getElementById(`slide-${index}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  };

  const nextSlide = () => {
    const nextIndex = (activeSlide + 1) % slides.length;
    goToSlide(nextIndex);
  };

  const prevSlide = () => {
    const prevIndex = (activeSlide - 1 + slides.length) % slides.length;
    goToSlide(prevIndex);
  };

  return (
    <div className="relative w-full overflow-hidden shadow-lg">
      {/* Botones de Flechas (Anterior / Siguiente) */}
      <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2 pointer-events-none z-50">
        <button
          onClick={prevSlide}
          className="btn btn-circle btn-sm md:btn-md btn-neutral pointer-events-auto opacity-80 hover:opacity-100"
          aria-label="Anterior"
        >
          ❮
        </button>
        <button
          onClick={nextSlide}
          className="btn btn-circle btn-sm md:btn-md btn-neutral pointer-events-auto opacity-80 hover:opacity-100"
          aria-label="Siguiente"
        >
          ❯
        </button>
      </div>

      {/* Carrusel de DaisyUI */}
      <div className="carousel w-full flex z-0">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            id={`slide-${index}`}
            className="carousel-item relative w-full shrink-0 snap-start h-64 md:h-96 z-0"
          >
            <img
              src={slide.image}
              alt={slide.title || `Slide ${index + 1}`}
              className="w-full h-full object-cover z-0"
            />
            
            {/* Overlay opcional para texto */}
            {(slide.title || slide.description) && (
              <div className="absolute inset-0 bg-linear-to-t from-black/70 via-black/20 to-transparent flex flex-col justify-end p-6 text-white">
                {slide.title && <h3 className="text-xl font-bold">{slide.title}</h3>}
                {slide.description && <p className="text-sm opacity-90">{slide.description}</p>}
              </div>
            )}
          </div>
        ))}
      </div>


      {/* Indicadores inferiores (Puntos / Dots) */}
      <div className="flex justify-center w-full py-3 gap-2 absolute bottom-2 left-0 right-0 z-50">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`btn btn-xs btn-circle transition-all ${
              activeSlide === index ? 'btn-info w-6 rounded-full' : 'btn-ghost bg-white/50'
            }`}
            aria-label={`Ir a diapositiva ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};